import * as types from './types';

export const getControlInfoLicenseCount = () => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(setLoading(true));
    MPWWebApi.getGeneric('controlinfo/getlicensecount')
      .then(response => {
        dispatch({
          type: types.LICENSEASSIGNSITE_GET_LICENSED_COUNT,
          payload: response,
        });
        dispatch(setLoading(false));
      })
      .catch(error => {
        dispatch({
          type: types.LICENSEASSIGNSITE_GET_LICENSED_COUNT_ERROR,
          payload: error.response,
        });
        dispatch(setLoading(false));
      });
  };
};

export const postLicenseAssignSiteUpdate = siteCollection => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(setLoading(true));
    return new Promise((resolve, reject) => {
      MPWWebApi.postGenericInsertUpdate(
        'sitemaster/UpdateLicenses',
        siteCollection
      )
        .then(response => {
          dispatch({
            type: types.LICENSEASSIGNSITE_UPDATE,
            payload: response,
          });
          dispatch(setLoading(false));
          resolve(response);
        })
        .catch(error => {
          dispatch({
            type: types.LICENSEASSIGNSITE_ERROR,
            payload: error.response,
          });
          dispatch(setLoading(false));
          reject(error.response);
        });
    });
  };
};

export const getLicenseAssignSite = resourceName => {
  return (dispatch, getState, MPWWebApi) => {
    dispatch(setLoading(true));
    MPWWebApi.getGeneric(resourceName)
      .then(response => {
        dispatch({
          type: types.LICENSEASSIGNSITE_GET,
          payload: response,
        });
        dispatch(setLoading(false));
      })
      .catch(error => {
        dispatch({
          type: types.LICENSEASSIGNSITE_ERROR,
          payload: error.response,
        });
        dispatch(setLoading(false));
      });
  };
};

export const clearErrors = () => {
  return {
    type: types.LICENSEASSIGNSITE_CLEAR_ERROR,
  };
};

export const updateLicenseAssignSiteCollection = item => {
  return {
    type: types.LICENSEASSIGNSITE_UPDATE_COLLECTION,
    payload: item,
  };
};

export const setLoading = isLoading => {
  return {
    type: types.LICENSEASSIGNSITE_LOADING,
    payload: isLoading,
  };
};



// WEBPACK FOOTER //
// ./src/pages/assignlicense/state/actions.js